<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md8>
        <v-card title>
          <v-card-title>
            <h2>Asignar Permisos a Rol : {{ rol.nombre }}</h2>
            <v-spacer></v-spacer>
            <v-btn icon dark color="red" @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <v-radio-group
                v-model="action.special"
                row
                @change="accessGlobal">
                <v-radio label="Acceso total" value="all-access"></v-radio>
                <v-radio label="sin Acceso" value="no-access"></v-radio>
                <v-radio label="Manual" value=" "></v-radio>
              </v-radio-group>
            </v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Clave</th>
                    <th class="text-left">Nombre</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in table.body.data" :key="index">
                    <td>{{ item.slug }}</td>
                    <td>{{ item.nombre }}</td>
                    <td class="switchAlig">
                      <v-switch
                        v-model="item.selected"
                        label="Activo"
                        color="success"
                        hide-details
                        class="switch"
                        @change="setpermissionsAssign(item)"
                      >
                      </v-switch>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import router from '@/router'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          {
            title: 'Refrescar',
            icon: 'mdi-cached',
            color: 'primary',
            action: 'refreshData'
          },
          {
            title: 'Nuevo',
            icon: 'mdi-plus',
            color: 'success',
            action: 'newData'
          }
        ],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Email', value: 'email', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    action: {
      rol_id: 0,
      check: false,
      permiso_id: 0,
      special: ' '
    },
    permisos: [],
    rol: {}
  }),
  components: {},
  mounted () {
    if (this.$route.params.id) {
      this.action.rol_id = this.$route.params.id
    }
    this.PostListObjects({ url: '/auth/permiso/list' })
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },

    ...mapActions(['PostListObjects', 'PostObjectSeccound', 'PostObject']),
    accessGlobal (e) {
      let title = ''
      if (e === 'all-access') title = `Dar acceso Total al rol ${this.rol.nombre}`
      else if (e === 'no-access') title = `Restringir acceso Total al rol ${this.rol.nombre}`
      else title = `Registrar acceso Manual al rol ${this.rol.nombre}`

      this.$swal.fire({
        title: title,
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Aplicar!',
        cancelButtonText: 'Cerrar'
      }).then((result) => {
        if (result.value) {
          this.action.check = true
          this.PostObjectSeccound({ url: '/auth/rol/set-pass', data: this.action })
        } else {
          this.action.special = ' '
        }
      })
    },
    setpermissionsAssign (item) {
      this.action.permiso_id = item.id
      this.action.check = item.selected
      this.PostObjectSeccound({ url: '/auth/rol/set-pass', data: this.action })
    },
    close () {
      router.push({ name: 'ViewRoles' })
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_objects', 'get_object'])
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.permisos = vals
        this.PostObject({ url: '/auth/roles', data: { id: this.action.rol_id } })
      }
    },
    get_object (val) {
      if (val) {
        this.rol = val[0]
        this.permisos.map(i => {
          this.rol.permisos.map(j => {
            if (i.slug === j.slug) {
              i.selected = true
            }
          })
        })
        this.table.body.data = this.permisos
      }
    }

  }
}
</script>

<style>
.switch {
  margin: 0 auto;
}
</style>
